// GYIK — programonkénti kérdés-válaszok.
// comingSoon: true → a gomb "Hamarosan" jelzést kap, a kérdések nem jelennek meg.
export const buildFaqPrograms = (paidAssessment = false) => [
  {
    id: 'eletmodvalto',
    button: 'Életmódváltó Program kérdései',
    title: 'Életmódváltó Program — Gyakran ismételt kérdések',
    comingSoon: false,
    faqs: [
      {
        q: 'Kezdőként is elkezdhetem, vagy ez haladóknak való?',
        a: 'Kifejezetten kezdőknek és újrakezdőknek szól. Ha évek óta nem mozogtál, vagy még soha nem edzettél rendszeresen, akkor jó helyen vagy. Az egész program onnan indul, ahol most tartasz. Nem kell hozzá előzetes tudás, se jó kondi — azt is megtanítom, hogyan kell egyáltalán helyesen elvégezni a gyakorlatokat.',
      },
      {
        q: 'Mi történik az első alkalommal?',
        a: 'Az első alkalom egy alapos állapotfelmérés és konzultáció. Átbeszéljük az egészségi hátteredet, a céljaidat és az életmódodat, felmérem pár egyszerű mozgáson keresztül, hogy lássam, mi biztonságos neked, és már ezen az alkalmon megtanulsz néhány gyakorlatot. A végén közösen kitűzünk egy reális célt. Semmi megalázó vagy kényelmetlen dolog — ez rólad szól.',
      },
      {
        q: 'Kell koplalnom vagy szigorú diétát tartanom?',
        a: 'Nem. A program lényege pont a fenntartható út: nincs koplalás, nincs éhezés. Az étrendet az irodai, mozgalmas hétköznapokhoz igazítjuk, hogy hosszú távon is tartható legyen — ne egy pár hetes kínlódás, ami után visszahízol mindent.',
      },
      {
        q: 'Mennyi idő alatt látok eredményt?',
        a: 'Az első hetek a technikáról és a szokások kialakításáról szólnak — a látványos rész ezután jön. Reális elvárással: rendszeres munkával 12 hét alatt érezhető változást tapasztalsz az energiádban és a közérzetedben, a testeden pedig fokozatosan. Csodát nem ígérek, de ha jössz, az eredmény biztosan épül — és látszani fog.',
      },
      {
        q: 'Segít a hátfájásomon és a rossz testtartásomon?',
        a: 'Igen, ez a program egyik fő fókusza. Az ülőmunka tipikus következményeire — merev hát, gyenge törzs, előre eső vállak — célzott gyakorlatokkal dolgozunk. Fontos: ha komoly, orvosi hátterű panaszod van, azt előbb tisztázzuk, és szükség esetén orvoshoz irányítalak — a felmérésen ezt is átnézzük.',
      },
      {
        q: 'Rég mozogtam / idősebb vagyok / van egészségügyi problémám — nekem is biztonságos?',
        a: 'Pontosan ezért kezdünk mindig felméréssel és egészségügyi szűréssel. Ha bármi olyat találunk, ami óvatosságot kíván (pl. magas vérnyomás, ízületi vagy szívprobléma), azt előbb orvossal tisztázzuk, mielőtt terhelnénk. A programot mindig a te állapotodhoz igazítom, nem fordítva. Valódi személyi edzés, személyedre szabva.',
      },
      {
        q: 'Mennyibe kerül?',
        a: '8 alkalom / hó — 45.000 Ft, vagy 12 alkalom / hó — 60.000 Ft, plusz a terembérlet 21.000 Ft. Az árban benne van a személyes 1:1 edzés, az étrend, a heti haladás-konzultáció és a 24 órán belüli válaszadás. Nincs rejtett költség.',
      },
      {
        q: 'Ki kell fizetnem a felmérést?',
        a: paidAssessment
          ? 'A felmérés díja 10.000 Ft, ha csak a felmérésre van szükséged. Ha viszont bérletet veszel, ezt teljes egészében beszámítom az árba — ilyenkor csak a programot kell kifizetned. Emellett van egy 20 perces ingyenes, kötetlen konzultáció is: ott nincs felmérés, csak beszélgetünk, és bármit kérdezhetsz. Személyesen a BB Gymben vagy online – ahogy neked kényelmes.'
          : 'Nem. Az állapotfelmérés INGYENES — bérletvásárlás nélkül is. Emellett van egy 20 perces ingyenes, kötetlen konzultáció is: ott nincs felmérés, csak beszélgetünk, és bármit kérdezhetsz. Személyesen a BB Gymben vagy online – ahogy neked kényelmes.',
      },
      {
        q: 'Hol lesznek az edzések?',
        a: 'BB Gym, Miskolc — 3526 Miskolc, Szeles u. 71. A parkolás biztosított és díjmentes.',
      },
      {
        q: 'A program ára tartalmazza a terembérletet?',
        a: 'Nem. A feltüntetett árak az edzői mentorálás (személyi vagy kiscsoportos edzés) díját és a részletes állapotfelmérést (0. alkalom) tartalmazzák. A BB Gym Miskolc terembe való belépést / terembérletet a résztvevő külön váltja meg a helyszínen. A belépő aktuális díját szívesen átbeszéljük az ingyenes konzultáción.',
      },
      {
        q: 'Mi van, ha le kell mondanom egy alkalmat?',
        a: 'Ha legalább 24 órával előtte szólsz, díjmentesen áttesszük egy másik időpontra. Ha van folyamatban lévő bérleted, azt bérletenként egyszer be is fagyaszthatod, legfeljebb 2 hétre. Ha valami sürgős jönne közbe, rugalmas vagyok — csak időben szólj.',
      },
    ],
  },
  {
    id: 'hipertrofia',
    button: 'Izomépítés és formázás kérdései',
    title: 'Izomépítés és formázás — Gyakran ismételt kérdések',
    comingSoon: false,
    faqs: [
      {
        q: 'Miben más ez, mint amit egyedül is megcsinálnék egy edzésterv-appból?',
        a: 'Egy általános app nem lát téged: nem tudja, hogyan mozogsz, hol vannak a gyenge pontjaid, mit bír a vállad vagy a derekad. Itt a terv a te személyedre van szabva — a felmérésed, a testarányaid és a haladásod alapján —, és hétről hétre igazítom ahhoz, amit a naplód mutat. A különbség a folyamatos korrekció: nem egy statikus PDF-et kapsz, hanem egy tervet, ami veled együtt változik.',
      },
      {
        q: 'Mit jelent nálad a tudományosan megalapozott edzés a gyakorlatban?',
        a: 'Azt, hogy nem megérzésből változtatunk, hanem az adataid alapján. Fokozatosan, tervezetten növeljük a terhelést, minden izomcsoport annyi munkát kap, amennyi a fejlődéshez kell, a gyakorlatokat szabályosan végezzük, és mérjük is a haladást (mennyit emelsz, mennyi összmunkát végzel, mennyire volt nehéz). Így számokban látod a fejlődésedet, nem csak érzésre.',
      },
      {
        q: 'Kell hozzá tapasztalat? Kinek nem való ez a program?',
        a: 'Akkor való neked, ha már edzel, de elakadtál, vagy látványosabb eredményt szeretnél — tehát ismered az alapgyakorlatokat és tudsz önállóan edzeni. Ha még most kezdesz, az Életmódváltó Program a jó belépő, onnan később ide is át lehet lépni. A váltást mindig közösen döntjük el, a fejlődésed alapján.',
      },
      {
        q: 'Hogyan méred a fejlődést?',
        a: 'Az edzésnaplódból: gyakorlatonként követjük, mennyit emelsz és mennyi munkát végzel. Ez megmutatja, ha egy gyakorlatnál megálltál — vagyis az adott mozgásban elérted a jelenlegi maximumodat —, még mielőtt hetekig ott ragadnál. Emellett testadatokat (súly, körméretek) is követünk, hogy lásd a valós összképet, ne csak a mérleg egyetlen számát.',
      },
      {
        q: 'Segítesz a táplálkozásban és az étrendkiegészítőkben is?',
        a: 'Igen: a célodhoz igazított étrend és a fehérje, szénhidrát, zsír mennyiségének beállítása is a program része. Az étrendkiegészítőknél általános, legális, vény nélküli szerekről adok tájékoztatást (mi indokolt, mi felesleges) — ez nem orvosi vagy gyógyszeres tanács, és tiltott, teljesítménynövelő szerekkel nem foglalkozom.',
      },
      {
        q: 'Mennyibe kerül?',
        a: '8 alkalom / hó — 55.000 Ft, vagy 12 alkalom / hó — 65.000 Ft. A program nem tartalmazza a kondibérlet árát. Amit tartalmaz: tudományosan megalapozott izomtömeg-növelő tervezés, beépített haladáskövető és heti check-in a fiókodban, tervezett, fokozatos erősödés, az anatómiádhoz igazított edzésterv, rád szabott táplálkozási terv a fehérje, szénhidrát és zsír beállításával, étrendkiegészítő-tanácsadás, 24 órán belüli válaszadás, valamint személyes 1:1 edzés és mentorálás. Nincs rejtett költség.',
      },
      {
        q: 'A program ára tartalmazza a terembérletet?',
        a: 'Nem. A feltüntetett árak az edzői mentorálás (személyi vagy kiscsoportos edzés) díját és a részletes állapotfelmérést (0. alkalom) tartalmazzák. A BB Gym Miskolc terembe való belépést / terembérletet a résztvevő külön váltja meg a helyszínen. A belépő aktuális díját szívesen átbeszéljük az ingyenes konzultáción.',
      },
    ],
  },
  {
    id: 'kiscsoportos',
    button: 'Kiscsoportos Személyi Edzés kérdései',
    title: 'Kiscsoportos Személyi Edzés — Gyakran ismételt kérdések',
    comingSoon: false,
    faqs: [
      {
        q: 'Teljesen kezdő vagyok, még soha nem edzettem. Ez akkor is nekem való?',
        a: 'Igen — kifejezetten kezdőknek találtam ki. Nem kell semmit tudnod előre, nem kell „formában lenned" hozzá. Az első alkalomtól kezdve a saját szintedről indulunk, és lépésről lépésre haladunk. Itt nincs ciki kérdés, és nincs elvárás, aminek meg kellene felelned.',
      },
      {
        q: 'Félek egyedül lemenni a terembe. Segít ebben a kiscsoport?',
        a: 'Pontosan ezért van. Maximum 2-3 fős, állandó társasággal edzel, végig mellettem — így sosem maradsz magadra, és nem te vagy „az egyetlen kezdő" egy tömegben. A legtöbben pár alkalom után mondják, hogy sokkal magabiztosabban mozognak a teremben.',
      },
      {
        q: 'Mi van, ha lemaradok a többiektől, vagy nem bírom a tempót?',
        a: 'Nem fogsz, mert nem egy közös, mindenkire ugyanúgy ráerőltetett órát csinálunk. A csoportban mindenki a saját, személyre szabott tervét kapja — csak egymás mellett, társaságban edzitek. A te terhelésed a te szintedhez igazodik, nem máséhoz.',
      },
      {
        q: 'Hányan vagyunk egy csoportban?',
        a: 'Legfeljebb 3 fő. Ez pont annyi, hogy mindenkire jusson figyelem és javítás, de már legyen közösség és lendület — nem tömegóra.',
      },
      {
        q: 'Jöhetek a barátommal / párommal / családtagommal?',
        a: 'Nagyon szívesen — sőt, sokaknak így a legkönnyebb belevágni. Ha ketten-hárman jöttök, garantáltan együtt edzetek. A jelentkezéskor csak jelezd, hogy kivel jönnél.',
      },
      {
        q: 'Fogyni / erősödni / jobb közérzetet szeretnék. Jó ez nekem?',
        a: 'Igen. A terv mindig a te célodhoz igazodik, legyen az fogyás, erősödés, jobb testtartás vagy egyszerűen a rendszeres, egészséges mozgás. Rekreációs fókusz — nem versenysport.',
      },
      {
        q: 'Nőként / férfiként / idősebben / visszatérőként is jó nekem?',
        a: 'Mindenkinek. Kezdőket, visszatérőket (sérülés, szülés, hosszabb kihagyás után) és a csak „kicsit mozogni vágyókat" is szívesen fogadok, kortól és nemtől függetlenül.',
      },
      {
        q: 'Meddig tart egy alkalom, és milyen gyakran járjak?',
        a: 'Egy alkalom kb. 60 perc. Kezdőként heti 2-3 alkalom az ideális — ezért van 8 és 12 alkalmas havi csomag is, hogy a saját ritmusodhoz válaszd.',
      },
      {
        q: 'Kell külön terembérlet a BB Gymbe?',
        a: 'Igen, a teremhasználathoz a BB Gym belépője / bérlete külön szükséges, a program díja emellé jön. Az ismerkedő beszélgetésen ezt is átbeszéljük, hogy pontosan lásd, mivel számolj.',
      },
      {
        q: 'Mennyibe kerül?',
        a: 'Havi bérlet formájában megy, létszám és alkalomszám szerint — fejenként kedvezőbb, mint a személyi 1:1 edzés (alkalomra vetítve nagyjából 2.750–3.750 Ft/fő). A pontos csomagokat a programoldalon találod. Fontos: ez havi bérlet, nincs alkalmankénti fizetés — az alkalmankénti ár csak tájékoztató egységár.',
      },
      {
        q: 'Mi van, ha egyszer nem tudok elmenni? Lemondható egy alkalom?',
        a: 'Ha legalább 24 órával előtte szólsz, díjmentesen áttesszük egy másik időpontra. Ha van folyamatban lévő bérleted, azt bérletenként egyszer be is fagyaszthatod, legfeljebb 2 hétre. Ha valami sürgős jönne közbe, rugalmas vagyok — csak időben szólj.',
      },
      {
        q: 'Kell előtapasztalat vagy saját felszerelés?',
        a: 'Nem. Elég egy kényelmes edzőruha és cipő — a többit a teremben megoldjuk. A gyakorlatokat végig mutatom és javítom.',
      },
      {
        q: 'Hogyan kezdek neki?',
        a: paidAssessment
          ? 'Három egyszerű lépés: 1) foglalj egy ingyenes, 20 perces ismerkedő beszélgetést (személyesen a BB Gymben vagy online, ahogy neked kényelmes); 2) ha passzol, jön egy részletes állapotfelmérő konzultáció (60 perc, 10.000 Ft), ahol felmérjük a céljaidat és a mozgásállapotodat; 3) ezután egyeztetjük az időpontot, és belevágunk.'
          : 'Három egyszerű lépés: 1) foglalj egy ingyenes, 20 perces ismerkedő beszélgetést (személyesen a BB Gymben vagy online, ahogy neked kényelmes); 2) ha passzol, jön az INGYENES, 60 perces állapotfelmérő konzultáció, ahol felmérjük a céljaidat és a mozgásállapotodat; 3) ezután egyeztetjük az időpontot, és belevágunk.',
      },
      {
        q: 'Mi van, ha kiderül, hogy inkább 1:1 edzés kellene (vagy fordítva)?',
        a: 'Teljesen rugalmas. Ha menet közben úgy érzed, hogy jobban passzolna az egyéni forma — vagy épp a kiscsoport —, váltunk. A cél, hogy neked a legjobb legyen.',
      },
      {
        q: 'Nem találtad meg a kérdésed?',
        a: 'Írj bátran Instagramon (@oroszcoaching) vagy foglalj egy kötetlen 20 perces beszélgetést a oroszcoaching.hu oldalon — minden kérdésre őszintén válaszolok, nyomás nélkül.',
      },
    ],
  },
  {
    id: 'online-coaching',
    button: 'Online Coaching program kérdései',
    title: '1:1 Online Mentorálás — Gyakran ismételt kérdések',
    comingSoon: false,
    faqs: [
      {
        q: 'Hogyan működik, ha nem vagy ott velem személyesen?',
        a: 'Kapsz egy rád szabott edzéstervet egy online felületen, ahol minden egy helyen van: a terv, az edzésnaplód és a haladásod. Te edzés közben beírod, mi ment ki (súly, ismétlés), én pedig távolról követem, és a naplód alapján hétről hétre igazítom a tervet. Rendszeres visszajelzést kapsz, nem vagy magadra hagyva — a kérdéseidet egy kis chat ablakba írod be, és ott is válaszolok neked.',
      },
      {
        q: 'Honnan tudom, hogy tényleg foglalkozol velem, és nem egy sablon-tervet kapok?',
        a: 'Mert a terved a te felméréseden és a te naplódon alapul, és látom, ha nem tartod a tervet, vagy ha megálltál, vagyis elérted a jelenlegi maximumodat. Az online coaching nálam nem „itt egy PDF, boldogulj". Heti 1 konzultáció videón és üzenetben, a fiókodból pedig bármikor írhatsz — és 24 órán belül választ kapsz a kérdéseidre.',
      },
      {
        q: 'Ellenőrzöd a technikámat, ha nem látsz élőben?',
        a: 'Igen — felveszed a gyakorlatot telefonnal, elküldöd, és én kielemzem, javítom. Ez az online forma egyik legfontosabb része. Így a technikád akkor is fejlődik és biztonságos marad, ha nem egy teremben vagyunk.',
      },
      {
        q: 'Kinek jó inkább az online, és kinek a személyes?',
        a: 'Az online akkor ideális, ha önállóan tudsz edzeni, van hozzáférésed edzőteremhez vagy felszereléshez, és a rugalmasság fontos (a saját időbeosztásod szerint edzel). Ha még most kezdesz, vagy sok kézzelfogható korrekció kell, akkor a személyes edzés a jobb belépő — később átválthatsz online formára.',
      },
      {
        q: 'Mi kell hozzá? Milyen felszerelés?',
        a: 'Edzőterem-hozzáférés vagy alap otthoni felszerelés, és egy telefon a naplózáshoz és a videókhoz — a tervet ahhoz igazítom, amihez hozzáférsz. Ha bérletet veszel, kapsz egy fiókot, amibe a honlapon beléphetsz: ott lesz az edzésterved (ki is nyomtathatod), telefonról is kényelmesen megy a naplózás és a nyomon követés, és ott írhatsz nekem — ott is válaszolok. A videókat Drive-on megosztva küldheted, az tökéletes.',
      },
      {
        q: 'Mennyibe kerül az online, és miben más az ára a személyeshez képest?',
        a: 'Az online csomag ára 25.000 Ft / hó. Tartalma: egyedi, anatómiára szabott edzésterv, beépített haladáskövető és heti check-in a fiókodban, heti videós forma- és technikaelemzés, üzenetváltás munkanapokon garantált 24 órán belüli válaszadással, havi étrend-felülvizsgálat és finomhangolás, teljesen rugalmas időbeosztás. Azért olcsóbb a személyes edzésnél, mert nincs benne a teremben együtt töltött idő — cserébe teljesen rugalmas, a saját időbeosztásod szerint edzel.',
      },
    ],
  },
];

// Visszafelé kompatibilis export (ingyenes felmérés az alapértelmezés).
export const FAQ_PROGRAMS = buildFaqPrograms(false);
